import { useEffect, useRef } from 'react';
import { io, Socket } from 'socket.io-client';

let socket: Socket | null = null;

function getSocket(): Socket {
  if (!socket) {
    socket = io('https://zoikanalyst.com', {
      path: '/socket.io',
      transports: ['websocket', 'polling'],
    });
    socket.on('connect', () => console.log('🔌 Socket conectado'));
    socket.on('disconnect', () => console.log('🔌 Socket desconectado'));
  }
  return socket;
}

export function useSocketEvent(event: string, callback: () => void) {
  const cbRef = useRef(callback);
  cbRef.current = callback;

  useEffect(() => {
    const sock = getSocket();
    const handler = () => cbRef.current();
    sock.on(event, handler);
    return () => { sock.off(event, handler); };
  }, [event]);
}
